import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { VolumeTypeEnum } from 'elements-sdk'

@Injectable({ providedIn: 'root' })
export class StorageConstants {
  constructor (private translate: TranslateService) { }

  readonly renameOptions = [
    {
      value: 'rename',
      name: this.translate.instant('Rename'),
      description: this.translate.instant('Rename the whole folder'),
    }, {
      value: 'merge',
      name: this.translate.instant('Merge'),
      description: this.translate.instant('Descent into folders and rename files if needed'),
    },
  ]

  readonly overwriteOptions = [
    { value: null, name: this.translate.instant('Skip') },
    { value: 'warn', name: this.translate.instant('Warn') },
    { value: 'number', name: this.translate.instant('Add a number') },
    { value: 'timestamp', name: this.translate.instant('Add a timestamp') },
    { value: 'overwrite', name: this.translate.instant('Overwrite') },
  ]

  readonly folderOptions = {
    number: this.renameOptions,
    timestamp: this.renameOptions,
    warn: [
      {
        value: 'rename',
        name: this.translate.instant('Whole folder'),
        description: this.translate.instant('Warn once about whole folder'),
      }, {
        value: 'merge',
        name: this.translate.instant('Files'),
        description: this.translate.instant('Descend into folders and warn about each existing file'),
      },
    ],
    overwrite: [],
    'null': [
      {
        value: 'rename',
        name: this.translate.instant('Whole folder'),
        description: this.translate.instant('Skip the whole folder'),
      }, {
        value: 'merge',
        name: this.translate.instant('Files'),
        description: this.translate.instant('Descend into folders and skip files if needed'),
      },
    ],
  }

  readonly protocolNames = {
    smb: 'SMB',
    afp: 'AFP',
    nfs: 'NFS',
    disk: this.translate.instant('Network drive'),
    unc: this.translate.instant('Network folder'),
  }

  readonly volumeTypes = [
    {
      type: VolumeTypeEnum.Generic,
      name: this.translate.instant('Local-only folder'),
    },
    {
      type: VolumeTypeEnum.GenericMount,
      name: this.translate.instant('Generic (mounted)'),
    },
    {
      type: VolumeTypeEnum.Snfs,
      name: 'StorNext',
    },
    {
      type: VolumeTypeEnum.Btrfs,
      name: 'BTRFS',
    },
    {
      type: VolumeTypeEnum.Lizardfs,
      name: 'LizardFS',
    },
    {
      type: VolumeTypeEnum.Bcachefs,
      name: 'BCacheFS',
    },
    {
      type: VolumeTypeEnum.Beegfs,
      name: 'BeeGFS',
    },
    {
      type: VolumeTypeEnum.Onefs,
      name: 'OneFS',
    },
    {
      type: VolumeTypeEnum.Cloud,
      name: 'Cloud',
    },
  ]
}
